<div class="card" [class.learned]="variant === 'learned'" [attr.data-status]="proposal.status">
  <div class="card-head">
    <span class="kind">{{ variant === 'learned' ? 'Learned' : label }}</span>
    <span class="pill" [class.pending]="pending" [class.rejected]="proposal.status === 'rejected'"
      [class.tag]="!pending && proposal.status !== 'rejected'">{{ proposal.status }}</span>
    <span class="muted" *ngIf="proposal.decidedBy">by {{ proposal.decidedBy }}</span>
    <span class="muted">#{{ proposal.id }}</span>
  </div>

  <ng-container *ngIf="variant === 'learned'; else copilotBody">
    <p class="note text">{{ note }}</p>
    <p class="muted">{{ proposal.reason }}</p>
  </ng-container>
  <ng-template #copilotBody>
    <dl class="payload" *ngIf="payloadLines.length">
      <ng-container *ngFor="let l of payloadLines">
        <dt>{{ l.key }}</dt>
        <dd class="text">{{ l.value }}</dd>
      </ng-container>
    </dl>
    <p class="reason text">{{ proposal.reason }}</p>
  </ng-template>

  <p class="muted" *ngIf="!pending && resultLine">Result: {{ resultLine }}</p>

  <div class="row" *ngIf="rewording">
    <input class="input grow" [(ngModel)]="rewordText" (keydown.enter)="saveReword()" maxlength="400"
      placeholder="The note, in your words" aria-label="Reworded note" />
    <button mat-flat-button color="primary" (click)="saveReword()" [disabled]="busy || !rewordText.trim()">Save note</button>
    <button mat-button (click)="rewording = false">Cancel</button>
  </div>

  <div class="row" *ngIf="pending && !rewording">
    <button mat-flat-button color="primary" class="approve" (click)="approve()" [disabled]="busy">
      {{ variant === 'learned' ? 'Accept' : 'Approve' }}
    </button>
    <button mat-stroked-button *ngIf="isStyleNote" (click)="startReword()" [disabled]="busy">Reword</button>
    <button mat-stroked-button class="reject" (click)="reject()" [disabled]="busy">
      {{ variant === 'learned' ? 'Drop' : 'Reject' }}
    </button>
  </div>
  <p class="problems" *ngIf="error">{{ error }}</p>
</div>
